
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class TradeMacroAssignmentGrid extends SiteEntityGrid<TradeMacroAssignmentRow, any> {
        protected getColumnsKey() { return 'Rebalancer.TradeMacroAssignment'; }
        protected getDialogType() { return TradeMacroAssignmentDialog; }
        protected getIdProperty() { return TradeMacroAssignmentRow.idProperty; }
        protected getLocalTextPrefix() { return TradeMacroAssignmentRow.localTextPrefix; }
        protected getService() { return TradeMacroAssignmentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}